import { render, staticRenderFns } from "./pre_number.vue?vue&type=template&id=30ed6122&scoped=true"
import script from "./pre_number.vue?vue&type=script&lang=js"
export * from "./pre_number.vue?vue&type=script&lang=js"
import style0 from "./pre_number.vue?vue&type=style&index=0&id=30ed6122&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ed6122",
  null
  
)

export default component.exports